/** Is our meta app through review?
 *
 *  Two founder-facing surfaces are backed by meta and gated on this:
 *  instagram (organic — posts through the meta graph) and meta ads (paid).
 *  Their adapters are BUILT. What is missing is permission to call meta with
 *  a founder's account, so every "connect" we render today walks them into a
 *  wall at meta's own consent screen and leaves them thinking magig is
 *  broken. Google ads is unaffected and is the one paid channel that ships
 *  for real right now.
 *
 *  ONE CONSTANT, SHARED, because the offer appears in more than one place.
 *  Gating the channels page alone would only move the wall: the home rail
 *  has a "connect instagram" card, onboarding has "connect meta (optional)",
 *  settings has its own — and the LANDING PAGE sells meta to people who
 *  have not signed up yet. A per-file boolean would get flipped in one and
 *  missed in the others — the same shape as the three schedulers that each
 *  answered "who gets notified" on their own.
 *
 *  WHY IT LIVES IN @magig/schemas rather than the dashboard: the landing
 *  site is a separate Next app and cannot import from apps/dashboard, so
 *  leaving the flag there would have forced a second copy — exactly the
 *  drift this constant exists to prevent. apps/dashboard/src/lib/
 *  meta-approval.ts now re-exports from here, so all four dashboard
 *  surfaces keep their existing import path.
 *
 *  Deliberately not an env var: it flips exactly once, on a date nobody can
 *  predict, and a build-time env var would put a founder-visible product
 *  state somewhere nobody reads. When review clears, set this to true and
 *  delete nothing else.
 *
 *  ⚠ TRUE SINCE 2026-10-12, AND NOT BECAUSE REVIEW CLEARED. The name now
 *  overstates what it knows: meta's app review has not been submitted, let
 *  alone approved (task df80eb9 — business verification is still waiting on
 *  a phone-ownership document). It is true because APP REVIEW ITSELF NEEDS
 *  IT TRUE: meta's reviewer has to watch the connect flow in a screencast
 *  and then walk it themselves with test credentials, and this constant is
 *  what hides the button they are being asked to click. A gate that makes
 *  the reviewed feature unreachable fails the review on a technicality.
 *
 *  The founder's call, with the reason recorded: nobody but the founder has
 *  an account today, so the wall this flag exists to prevent has nobody to
 *  walk into it. THAT IS THE ASSUMPTION TO RECHECK — the moment a second
 *  founder signs up, an unapproved meta app means their connect attempt
 *  dies at meta's consent screen, and this goes back to false until review
 *  actually clears.
 *
 *  The public landing site is unaffected either way: apps/landing mentions
 *  META_APPROVED only in COMMENTS (hero.tsx:39, faq.tsx:69) and had its
 *  meta copy removed by hand in s529, so flipping this does not start
 *  selling meta to strangers. Only the four authenticated dashboard
 *  surfaces change.
 *
 *  ALL FOUR DASHBOARD SURFACES ARE CONVERTED as of s523 — the channels
 *  page, the home rail, onboarding-checklist.tsx (which OMITS its step
 *  rather than disabling it, and resolves it without a skip so /home still
 *  unlocks) and settings/sections/instagram.tsx (the connect picker; an
 *  active connection keeps its panel). The landing site's pricing, hero,
 *  how-it-works, problem and faq copy follow as of s529.
 *
 *  ONE DOOR LEFT OPEN, deliberately: MetaBundleStatusRow's per-bundle
 *  "extend" in settings only renders under an ALREADY-active connection,
 *  and the standing rule is that a working connection is never severed
 *  because a flag flipped. */
export const META_APPROVED = true;
/** Copy for a surface that would otherwise offer a meta connection.
 *  Says WHY, because "coming soon" on something whose adapter is finished
 *  invites the founder to ask when — and the honest answer is "when meta
 *  says so", not "when we build it". */
export const META_PENDING_BLURB = "built and waiting on meta's app review.";
//# sourceMappingURL=meta-approval.js.map